var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"compreSportsMeet_selectTab",style:({
    '--mixtmt_greyColor11': _vm.colorsArr
      ? _vm.colorsArr[0]
      : _vm.currThemeObj.cssStyle.greyColor11,
    '--mixtmt_whiteColor': _vm.colorsArr
      ? _vm.colorsArr[1]
      : _vm.currThemeObj.cssStyle.whiteColor,
    '--mixtmt_greyColor2': _vm.colorsArr
      ? _vm.colorsArr[2]
      : _vm.currThemeObj.cssStyle.greyColor2,
    '--mixtmt_mainColor': _vm.colorsArr
      ? _vm.colorsArr[3]
      : _vm.currThemeObj.cssStyle.mainColor,
  })},_vm._l((_vm.tabArr),function(tab){return _c('span',{key:typeof tab.id === 'string' ? tab.id : tab.id[0],staticClass:"tabItem",class:[tab.act ? 'act' : '', _vm.borderColor ? 'border' : ''],domProps:{"textContent":_vm._s(tab.name)},on:{"click":function($event){return _vm.clickTab(tab)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }